export const REAUTH_REQUIRED_CODE = 'REAUTH_REQUIRED';

/**
 * Builds the auth-service `/auth` URL that starts the Google sign-in.
 *
 * `from` is the in-app path to return to after login; it travels to Google and back
 * inside the opaque `state` parameter. When the backend has flagged the user's Google
 * token as dead (POM-6122) the auth service itself adds the consent prompt during this
 * login, so the UI never needs to ask for it.
 */
// Same encoding as `encodeB64` in common/utils, inlined so the auth thunk and the idle
// hook do not pull the whole utils barrel (and its CSV/PDF dependencies) into the
// session-refresh path.
const encodeState = (value) => window.btoa(encodeURIComponent(value));

export const buildGoogleSignInUrl = ({ from = '/' } = {}) => {
  const combinedState = { state: from, appCode: 'POM' };
  const encodedState = encodeURIComponent(encodeState(JSON.stringify(combinedState)));

  return `${process.env.REACT_APP_GOOGLE_OAUTH_URL}/auth?state=${encodedState}`;
};

export const redirectToGoogleSignIn = (options) => {
  window.location.assign(buildGoogleSignInUrl(options));
};

/** Reads the GraphQL error code from a graphql-request ClientError. */
export const getGraphqlErrorCode = (error) => error?.response?.errors?.[0]?.extensions?.code;
